import React from 'react';
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { getApiHeader } from 'utlis/commonfunctions';
import { ToastContainer, toast } from "react-toastify";
import swal from 'sweetalert';
import Modal from 'react-bootstrap/Modal';
import DataTable from "react-data-table-component";
import SortIcon from "@material-ui/icons/ArrowDownward";








import Switch from "@mui/material/Switch";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftInput from "components/SoftInput";
import SoftButton from "components/SoftButton";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "layouts/authentication/components/Footer";
import BillingInformation from "layouts/billing/components/BillingInformation";
import Transactions from "layouts/billing/components/Transactions";
import { ThreeDots } from 'react-loader-spinner'


const SERVER_URL = process.env.REACT_APP_API_URL;


const styles = {
  wrapper: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backdropFilter: "blur(1px)",
    zIndex: 9999,
  },
};

function SearchAndAllocateReachargeVoucher() {
  const [activeTab, setActiveTab] = useState("pageOne")
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [retailerData, setRetailerData] = useState([])
  const [storeData, setStoreData] = useState([])
  const [rememberMe, setRememberMe] = useState(false);
  const [rememberMe1, setRememberMe1] = useState(false);
  const [allocateBox, setAllocateBox] = useState(false);
  const [retailerBox, setRetailerBox] = useState(false);
  const [modelVisibility, setModelVisibility] = useState(false);
  const [pid, setPid] = useState("");
  const [retailer_code, setRetailer_code] = useState("");
  const [retailerAddress, setRetailerAddress] = useState("")
  const [company, setCompany] = useState("")
  const [name, setName] = useState("")
  const [text, setText] = useState(false)
  const [button, setButton] = useState(false)
  const [selectedSimBaseIds, setSelectedSimBaseIds] = useState([]);
  const [seachStore, setSearchStore] = useState(false)
  const [delearDetails, setDelearDetails] = useState(false)
  const [selectedRetailerId, setSelectedRetailerId] = useState(null);
  const [retailerDetails, setRetailerDetails] = useState(true)
  const [isAllChecked, setIsAllChecked] = useState(false);
  const [selectedPlanVoucherIds, setSelectedPlanVoucherIds] = useState([]);
  const [databox, setDataBox] = useState(false)
  const [databox1, setDataBox1] = useState(false);
  const[showRetailerId,setShowRetailerId]=useState("")

  const [selectedRows, setSelectedRows] = useState(false);
  const [toggledClearRows, setToggleClearRows] = useState(false);
  const [tableView, setTableView] = useState(false);
  const[disable,setDisable]=useState(false)

  const rowsPerPage = 10;
  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentData = retailerData.slice(indexOfFirstRow, indexOfLastRow);
  const StoreData = storeData.slice(indexOfFirstRow, indexOfLastRow);
  const [formData, setFormData] = useState({
    control_number: "",
    voucher_code: "",
    retailer_code: "",
    plan_voucher_id: [],
    shop_code:"",
    box_number:"",
    bundle_number:"",

  });

  const handleSearch = async (e) => {
    e.preventDefault();
    if (
      formData.control_number === "" &&
      formData.voucher_code === "" &&
      formData.retailer_code === "" &&
      formData.plan_voucher_id === ""
    ) {
      toast.error("At least one input field must be filled");
      return;
    }


    const filteredFormData = Object.fromEntries(
      Object.entries(formData).filter(([key, value]) => value !== "" && (!Array.isArray(value) || value.length > 0))
    );
  
    // Check if filteredFormData is empty
    if (Object.keys(filteredFormData).length === 0) {
      toast.error("Please fill in at least one input field for searching");
      return;
    }
  

    const headers = await getApiHeader();
    try {
        setLoading(true)
      const response = await axios.post(`${SERVER_URL}allocate-physical-recharge-vouchers-to-dealers`, filteredFormData, {
        headers: headers
      });
      if (response.status === 200) {
        setDisable(true)
        setLoading(false)

        if (response.data.data !== null && response.data.data.length > 0) {

          setRetailerData(response.data.data)
          console.log("retailerData", retailerData.includes(response.data.plan_voucher_id))
          setDataBox(true)
          toast.success(response?.data?.message);
        } else {
          setDataBox(false)
          setRememberMe(false);
          setRememberMe1(false);
          toast.error("No data found during searching");
        }
        
      }

    } catch (error) {
      setDisable(true)
      setLoading(false)
      console.log(error)
      const errorMessage = error?.response?.data?.message || "An error occurred";
      if (typeof errorMessage === 'object') {
        Object.keys(errorMessage).forEach(key => {
          errorMessage[key].forEach(message => {
            toast.error(message);
          });
        });

      } else {
        toast.error(errorMessage);

      }
    }
  };










  const handleSubmit = async (e) => {
    if (e) {
      e.preventDefault();
    }
     setLoading(true)
    const headers = await getApiHeader();
    try {
      const response = await axios.post(`${SERVER_URL}get_retailer_details`, formData, {
        headers: headers
      });
      if (response.status === 200) {
        setLoading(false)
        const data = response.data.data
        setRetailerAddress(data.retailer_address)
        setCompany(data.retailer_company_name)
        setName(data.retailer_name)
        setButton(true)
        setDelearDetails(true)
        setRetailerBox(true)
        setRetailerDetails(true)
      }

    } catch (error) {
      setLoading(false)
      const errorMessage = error?.response?.data?.message || "An error occurred";
      if (typeof errorMessage === 'object') {
        Object.keys(errorMessage).forEach(key => {
          errorMessage[key].forEach(message => {
            toast.error(message);
          });
        });

      } else {
        toast.error(errorMessage);
      }
    }
  };

  const handleChange = (e) => {
    setDisable(false)
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handlePidChange = (e) => {
    const value = e.target.value
    setFormData({
      ...formData,
      retailer_code:value,
      shop_code: value
    });
    setShowRetailerId(value)

  }



  const handlePrevious = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleNext = () => {
    if (currentPage < Math.ceil(retailerData.length / rowsPerPage)) {
      setCurrentPage(currentPage + 1);
    }
  };



  const handleAllocateBox = (event, plan_voucher_id) => {
    setAllocateBox(true);

    if (event.target.checked) {
      setSelectedSimBaseIds(prevIds => [...prevIds, plan_voucher_id]);
      setFormData(prevFormData => ({
        ...prevFormData,
        plan_voucher_id: [...prevFormData.plan_voucher_id, plan_voucher_id]
      }));
    } else {
      setSelectedSimBaseIds(prevIds => prevIds.filter(id => id !== plan_voucher_id));
      setFormData(prevFormData => ({
        ...prevFormData,
        plan_voucher_id: prevFormData.plan_voucher_id.filter(id => id !== plan_voucher_id)
      }));
    }
  };





  const handleCheckAll = (event) => {
    const isChecked = event.target.checked;
    setIsAllChecked(isChecked);
    setAllocateBox(isChecked);

    if (isChecked) {
      const allIds = retailerData.map(data => data.plan_voucher_id);
      setSelectedPlanVoucherIds(allIds);
      setFormData(prevFormData => ({
        ...prevFormData,
        plan_voucher_id: allIds
      }));
    } else {
      setSelectedPlanVoucherIds([]);
      setFormData(prevFormData => ({
        ...prevFormData,
        plan_voucher_id: []
      }));
    }
  };

  const handleSetRememberMe = (e) => {
    setRememberMe(prevState => {
      const newRememberMeState = !prevState;
      setRetailerBox(newRememberMeState);
      return newRememberMeState;
    });

    setFormData(prevFormData => ({
      ...prevFormData,
      retailer_code: ""
    }));
    


    setRememberMe1(false);
    setDelearDetails(false);
    setButton(false);
    setShowRetailerId("")



  };

  const handleSetRememberMe1 = (e) => {
    setRememberMe1(prevState => {
      const newRememberMe1State = !prevState;
      setSearchStore(newRememberMe1State);
      return newRememberMe1State;
    });
    setRememberMe(false);
    setRetailerDetails(false)
    setFormData(prevFormData => ({
      ...prevFormData, 
      retailer_code: "",
      store_name: "",
      email: "",
      abn: "",
      state: "",
      city: "",
      postcode: "",
      street_name: "",
    }));
    

  };

  // const handleClose = (e) => {
  //   handleSubmit(e)
  // }
  const handleModal = () => {
    setModelVisibility(false)
  }

  const handleAllocate = async (e) => {
    e.preventDefault();
    setLoading(true)
    const headers = await getApiHeader();
    try {
      const response = await axios.post(`${SERVER_URL}allocate-vouchers`, formData, {
        headers: headers
      });
      if (response.status === 200) {
        setLoading(false)
        const data = response.data.data
        console.log("data", data)
      
        handleClear()

        swal({
          title: "Success",
          text: "Voucher Allocated Successfully",
          icon: "success",
          button: "Close"
        });
      }
      console.log("response", response.data.message);

    } catch (error) {
      console.log(error)
      setLoading(false)
      // const errorMessage = error?.response?.data?.message || "An error occurred";
      swal({
        title: "",
        text: "An error occured",
        icon: "error",
        button: "Close"
      });
      if (typeof errorMessage === 'object') {
        Object.keys(errorMessage).forEach(key => {
          errorMessage[key].forEach(message => {
            toast.error(message);
          });
        });

      } else {
        // toast.error(errorMessage);

      }
    }
  };



  /**    functions for search store */
  const handleBack = () => {
    setSearchStore(false)
    setRememberMe1(false)
    setButton(false);
    handleClear()
  }

 


  const handleStoreSearch = async (e) => {
    e.preventDefault();
   
    if (
      formData.retailer_code === "" &&
      formData.store_name === "" &&
      formData.email === "" &&
      formData.abn === "" &&
      formData.state === "" &&
      formData.city === "" &&
      formData.postcode === "" &&
      formData.street_name === ""

    ) {
      toast.error("At least one input field must be filled");
      setTableView(false);
      return;
    } else if (formData.street_name && (formData.city === "" && formData.postcode === "")) {
      toast.error("Please enter  post code or city name ");
      setTableView(false);
      return;
    } else if (formData.state && (formData.city === "" && formData.postcode === "")) {
      toast.error("Please enter street name or post code ");
      setTableView(false);
      return;
    }
    const filteredFormData = Object.fromEntries(
      Object.entries(formData).filter(([key, value]) => value !== "")
    );
    const headers = await getApiHeader();

    try {
      setLoading(true)
      const response = await axios.post(`${SERVER_URL}search-retailer-store`, filteredFormData, {
        headers: headers
      });
      
      if (response.status === 200) {
           setLoading(false)
        if (response.data.data !== null && response.data.data.length > 0) {
          setCurrentPage(1)
          setDataBox1(true)
          setStoreData(response.data.data)
           setRetailerData(response.data.data)
          toast.success(response.data.message);
        } else {
          setRetailerBox(false)
          setRememberMe1(false);
          setDelearDetails(false)
          setDelearDetails(false)
          setRetailerAddress("") 
          setCompany("")
          setName("")
          toast.error("No data found during searching");
        }
      }

    } catch (error) {
      setLoading(false)
      const errorMessage = error?.response?.data?.message || "An error occurred";
      if (typeof errorMessage === 'object') {
        Object.keys(errorMessage).forEach(key => {
          errorMessage[key].forEach(message => {
            toast.error(message);
          });
        });

      } else {
        toast.error(errorMessage);

      }
    }
  };



  const handleAllocateRetailer = (event, retailer_id) => {
    setAllocateBox(true);
    console.log("retailer_id", retailer_id);
    if (event.target.checked) {
      setSelectedRetailerId(retailer_id);
      setFormData((prevFormData) => ({
        ...prevFormData,
        retailer_code: retailer_id,
        shop_code: retailer_id
      }));
  
    } else {
      setSelectedRetailerId(null);
      setFormData((prevFormData) => ({
        ...prevFormData,
        retailer_code: "",
        shop_code:"",

      }));
    }
  };



  useEffect(() => {
    if (selectedRetailerId !== null) {
      handleSubmit();
    }
  }, [selectedRetailerId]);





  const columns = [

    {
      id: 1,
      name: "Control Number",
      selector: (row) => row.control_number,
    },
    {
      id: 2,
      name: "Voucher Code",
      selector: (row) => row.voucher_code,
     
    },
    {
      id: 3,
      name: "Channel",
      selector: (row) => row.channel,
     
    },
    {
      id: 4,
      name: "Retailer ID",
      selector: (row) => row.retailer?.retailer_code,
     
    },
    {
      id: 5,
      name: "Retailer Company Name",
      selector: (row) => row.retailer?.retailer_company_name,
    },
    {
      id: 6,
      name: "Bundle Number",
      selector: (row) => row.bundle_number,
    },
    {
      id: 7,
      name: "Box Number",
      selector: (row) => row.box_number,
    },
    {
      id: 8,
      name: "Plan Name",
      selector: (row) => row. plan_name,
    },
    


  ];


  const paginationComponentOptions = {
    selectAllRowsItem: true,
    selectAllRowsItemText: "ALL"
  };


  const handleChanges = ({ selectedRows }) => {
    const updatedVoucherCode = selectedRows.map(row => row.plan_voucher_id);
    setAllocateBox(true);
    setFormData(prevFormData => ({
      ...prevFormData,
      plan_voucher_id: updatedVoucherCode
    }));

    setSelectedRows(selectedRows);

  };



  const handleClearRows = () => {
    setToggleClearRows(!toggledClearRows);
  }

  const rowDisabledCriteria = row => row.retailer?.retailer_code;

  // const customStyles = {
  //   gyksGC: {
  //     style: {
  //       whiteSpace: "normal",
  //       overflow: "hidden",
  //       textOverflow: "ellipsis"
  //     }
  //   },
  //   fKWVwL: {
  //     style: {
  //       whiteSpace: "normal",
  //       overflow: "hidden",
  //       textOverflow: "ellipsis"
  //     }

  //   },
  //   rows: {
  //     style: {
  //       border: '1px solid #ccc', 
  //     },
  //   },
  //   headCells: {
  //     style: {
  //       backgroundColor: '#f0f0f0',
  //       border: '1px solid #ccc', 
  //     },
  //   },
  //   cells: {
  //     style: {
  //       border: '1px solid #ccc', 
  //     },
  //   },
  // };


  const customStyles = {
    gyksGC: {
      style: {
        whiteSpace: "normal",
        overflow: "hidden",
        textOverflow: "ellipsis"
      }
    },
    fKWVwL: {
      style: {
        whiteSpace: "normal",
        overflow: "hidden",
        textOverflow: "ellipsis"
      }

    },
    rows: {
      style: {
        border: '1px solid #ccc', // Add border to rows
      },
    },
    headCells: {
      style: {
        backgroundColor: '#f0f0f0',
        border: '1px solid #ccc', // Add border to header cells
      },
    },
    cells: {
      style: {
        border: '1px solid #ccc', // Add border to individual cells
      },
    },
  };


  const handleClear = () => {
    setFormData(prevFormData => ({
      ...prevFormData,
      retailer_code: "",
      store_name: "",
      email: "",
      abn: "",
      state: "",
      city: "",
      postcode: "",
      street_name: "",
      control_number: "",
      voucher_code:""
    }));    
    setDataBox1(false)
    setDataBox(false)
    setAllocateBox(false)
    setRetailerDetails(false)
    setSelectedRetailerId(null)  
    setName("")
    setCompany("")
    setRetailerAddress("")
    setDelearDetails(false)
    setButton(false)
    setShowRetailerId("")
    setRememberMe(false)  
    setRetailerBox(false);      
  };


  return (
    <DashboardLayout>
      <DashboardNavbar />
      <>
        {seachStore ? (
          <div>
            {loading && (
              <div style={styles.wrapper}>
                <ThreeDots
                  visible={loading}
                  height="80"
                  width="80"
                  color="#C11D6C"
                  radius="9"
                  ariaLabel="three-dots-loading"
                />
              </div>
            )}

            <div className="formbold-main-wrapper">
              <div className="formbold-form-wrapper">
                <h5 style={{ textAlign: "center" }}>Search Store And Allocate Recharge Voucher</h5>
                <form action="" method="" onSubmit={handleStoreSearch}>
                  <div className="formbold-mb-5 formbold-pt-3">
                    <label className="formbold-form-label formbold-form-label-2">
                    </label>
                    <div className="flex flex-wrap formbold--mx-3">
                      <div className="w-full sm:w-half formbold-px-3">
                        <div className="formbold-mb-5">
                          <label htmlFor="store_name" className="formbold-form-label">
                            Control Number
                          </label>
                          <input
                            type="text"
                            name="control_number"
                            id="control_number"
                            placeholder="Enter Control Number"
                            className="formbold-form-input"
                            value={""}
                            onChange={handleChange}
                            autoComplete="off"
                          />
                        </div>
                      </div>

                       <div className="w-full sm:w-half formbold-px-3">
                        <div className="formbold-mb-5">
                          <label htmlFor="store_name" className="formbold-form-label">
                            Email
                          </label>
                          <input
                            type="email"
                            name="email"
                            id="email"
                            placeholder="Enter Email Address"
                            className="formbold-form-input"
                            value={formData.email}
                            onChange={handleChange}
                            autoComplete="off"
                          />
                        </div>
                      </div> 

                      <div className="w-full sm:w-half formbold-px-3">
                        <div className="formbold-mb-5">
                          <label htmlFor="store_name" className="formbold-form-label">
                            Retailer Code
                          </label>
                          <input
                            type="text"
                            name="retailer_code"
                            id="retailer_code"
                            placeholder="Enter Retailer ID"
                            className="formbold-form-input"
                            value={formData.retailer_code}
                            onChange={handleChange}
                            autoComplete="off"
                          />
                        </div>
                      </div>
                      <div className="w-full sm:w-half formbold-px-3">
                        <div className="formbold-mb-5">
                          <label htmlFor="store_name" className="formbold-form-label">
                            ABN
                          </label>
                          <input
                            type="text"
                            name="abn"
                            id="abn"
                            placeholder="Enter ABN"
                            className="formbold-form-input"
                            value={formData.abn}
                            onChange={handleChange}
                            maxLength={12}
                            autoComplete="off"
                          />
                        </div>
                      </div>

                      <div className="w-full sm:w-half formbold-px-3">
                        <div className="formbold-mb-5">
                          <label htmlFor="store_name" className="formbold-form-label">
                            City
                          </label>
                          <input
                            type="text"
                            name="city"
                            id="city"
                            placeholder="Enter City Name"
                            className="formbold-form-input"
                            value={formData.city}
                            onChange={handleChange}
                            autoComplete="new-password"
                          />
                        </div>
                      </div>
                      <div className="w-full sm:w-half formbold-px-3">
                        <div className="formbold-mb-5">
                          <label htmlFor="store_name" className="formbold-form-label">
                            Post Code
                          </label>

                          <input
                            type="text"
                            name="postcode"
                            id="postcode"
                            placeholder="Enter Post Code"
                            className="formbold-form-input"
                            value={formData.postcode}
                            onChange={handleChange}
                            autoComplete="new-password"
                          />
                        </div>
                      </div>
                      <div className="w-full sm:w-half formbold-px-3">
                        <div className="formbold-mb-5">
                          <label htmlFor="store_name" className="formbold-form-label">
                            Street Name
                          </label>
                          <input
                            type="text"
                            name="street_name"
                            id="street_name"
                            placeholder="Enter Street Name"
                            className="formbold-form-input"
                            value={formData.street_name}
                            onChange={handleChange}
                            autoComplete="new-password"
                          />
                        </div>
                      </div>

                      <div className="w-full sm:w-half formbold-px-3">
                        <label htmlFor="store_name" className="formbold-form-label">
                          State
                        </label>
                        <select
                          className="formbold-form-input"
                          name="state"
                          id="state"
                          value={formData.state}
                          onChange={handleChange}
                        >
                          <option value="">Select State</option>
                          <option value="Act">ACT</option>
                          <option value="NSW">NSW</option>
                          <option value="NIT">NIT</option>
                          <option value="QLD">QLD</option>
                          <option value="SA">SA</option>
                          <option value="TAS">TAS</option>
                          <option value="VIC">VIC</option>
                          <option value="WA">WA</option>
                        </select>
                      </div>
                    </div>
                  </div>

                  <div className="search-store-buttons">
                    <button className="search-store-button" type="submit"><i class="fa fa-search"></i> Search</button>
                    {
                      databox1 && (
                        <button className="search-store-button" type="button" onClick={handleClear}>Clear</button>
                      )
                    }
                  </div>


                </form>
                {databox1 && (
                  <div className="container" style={{ marginTop: "10px" }}>
                    <div className="row">
                      <div className="col-md-12">
                        <div className="table-responsive">
                          <table id="mytable" className="table table-bordred ">
                            <thead>
                              <tr>
                                {/* <th>
                    <input type="checkbox" id="checkall" onChange={handleAllocateBox} />
                  </th> */}
                                <th>No</th>
                                <th>Allocate</th>
                                <th>Retailer ID</th>
                                <th>Retailer Name</th>
                                <th>Store Address</th>
                                <th>Email Address</th>
                              </tr>
                            </thead>
                            <tbody>

                              {StoreData.map((data, index) => (
                                <tr key={indexOfFirstRow + index}>
                                  <td>{indexOfFirstRow + index + 1}</td>
                                  <td>
                                    <input type="checkbox" className="checkthis" checked={selectedRetailerId === data.retailer_code} onChange={(event) => handleAllocateRetailer(event, data.retailer_code)}   />
                                  </td>
                                  <td>{data.retailer_code || "N/A"}</td>
                                  <td>{data.retailer_company_name || "N/A"}</td>
                                  <td style={{wordBreak:"break-all"}}>{data.retailer_store_address || "N/A"}</td>
                                  <td>{data.retailer_email || "N/A"}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                          <div className="clearfix" />

                          <div className="pagination">
                            {currentPage > 1 && (
                              <button className="previous" onClick={handlePrevious}>
                                 <i className="fa fa-chevron-left" aria-hidden="true"></i>  Previous
                              </button>
                            )}
                            {currentPage < Math.ceil(retailerData.length / rowsPerPage) && (
                              <button className="next" onClick={handleNext}>
                                Next <i className="fa fa-chevron-right" aria-hidden="true"></i>
                              </button>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {retailerDetails && (
                  <div classname="formbold-main-wrapper">
                    <div classname="formbold-form-wrapper">
                      <div className='trail delar-box'>
                        <SoftBox component="form" role="form" style={{ width: "20%" }} mx={"5%"} >
                          <SoftBox mb={2}>
                            <div className='details'>
                              <h6 className='details-name'>Dealer Name:<span>&nbsp;</span><span>&nbsp;</span>{name}</h6>
                              <h6 className='details-company'>Company/Store Name:<span>&nbsp;</span><span>&nbsp;</span>{company}</h6>
                              <h6 className='details-address'>Dealer Address:<span>&nbsp;</span><span>&nbsp;</span>{retailerAddress}</h6>
                            </div>
                          </SoftBox>
                          <SoftBox mt={2} mb={2} className="allocate" >
                            <SoftButton variant="gradient" className="allocate-button" style={{ backgroundColor: "#C11D6C", color: "white" }} onClick={handleAllocate}>
                              Allocate
                            </SoftButton>
                          </SoftBox>
                        </SoftBox>
                      </div>
                    </div>
                  </div>
                )}
                <button className='handle-back' onClick={handleBack}> back</button>
              </div>
            </div>
          </div>
        ) :
          <div>

            {loading && (
              <div style={styles.wrapper}>
                <ThreeDots
                  visible={loading}
                  height="80"
                  width="80"
                  color="#C11D6C"
                  radius="9"
                  ariaLabel="three-dots-loading"
                />
              </div>
            )}
            <div className="formbold-main-wrapper">
              <div className="formbold-form-wrapper">
                <h5 style={{ textAlign: "center" }}>Search And Allocate Recharge Voucher</h5>
                <form action="" method="" onSubmit={handleSearch} autoComplete="off">
                  <div className="formbold-mb-5 formbold-pt-3">
                    <label className="formbold-form-label formbold-form-label-2">
                    </label>
                    <div className="flex flex-wrap formbold--mx-3">
                      <div className="w-full sm:w-half formbold-px-3">
                        <div className="formbold-mb-5">
                          <label htmlFor="store_name" className="formbold-form-label">
                            Control Number
                          </label>
                          <input
                            type="text"
                            name="control_number"
                            id="control_number"
                            placeholder="Enter Control Number"
                            className="formbold-form-input"
                            value={formData.control_number}
                            onChange={handleChange}
                            autoComplete="off"
                          />
                        </div>
                      </div>

                      <div className="w-full sm:w-half formbold-px-3">
                        <div className="formbold-mb-5">
                          <label htmlFor="store_name" className="formbold-form-label">
                            Voucher Code
                          </label>
                          <input
                            type="text"
                            name="voucher_code"
                            id="voucher_code"
                            placeholder="Enter Voucher Code"
                            className="formbold-form-input"
                            value={formData.voucher_code}
                            onChange={handleChange}
                            autoComplete="off"
                          />
                        </div>
                      </div>



                      <div className="w-full sm:w-half formbold-px-3">
                        <div className="formbold-mb-5">
                          <label htmlFor="store_name" className="formbold-form-label">
                            Retailer Code
                          </label>
                          <input
                            type="text"
                            name="retailer_code"
                            id="retailer_code"
                            placeholder="Enter Retailer ID"
                            className="formbold-form-input"
                            value={formData.retailer_code}
                            onChange={handleChange}
                            autoComplete="off"
                          />
                        </div>
                      </div>

                      <div className="w-full sm:w-half formbold-px-3">
                        <div className="formbold-mb-5">
                          <label htmlFor="store_name" className="formbold-form-label">
                          Box Number
                          </label>
                          <input
                            type="text"
                            name="box_number"
                            id="box_number"
                            placeholder="Enter Box Number"
                            className="formbold-form-input"
                            value={formData.box_number}
                            onChange={handleChange}
                            autoComplete="off"
                          />
                        </div>
                      </div>

                      <div className="w-full sm:w-half formbold-px-3">
                        <div className="formbold-mb-5">
                          <label htmlFor="store_name" className="formbold-form-label">
                          Bundle Number
                          </label>
                          <input
                            type="text"
                            name="bundle_number"
                            id=" bundle_number"
                            placeholder="Enter Bundle Number"
                            className="formbold-form-input"
                            value={formData.bundle_number}
                            onChange={handleChange}
                            autoComplete="off"
                            maxLength={20}
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="search-store-buttons">
                    <button className="search-store-button" type="submit"><i class="fa fa-search" disabled={disable}></i> Search</button>
                    {
                      databox && (
                        <button className="search-store-button" type="button" onClick={handleClear}> Clear</button>
                      )
                    }
                  </div>

                </form>

                {databox && (
                  <div className="container" style={{ marginTop: "10px" }}>
                    <div className="row">
                      <div className="col-md-12">
                        <div className="table-responsive">
                          <div className="data-dummy-table">
                            <DataTable
                              title="Search and Allocate Recharge Voucher Details"
                              columns={columns}
                              data={retailerData}
                              defaultSortFieldId={1}
                              sortIcon={<SortIcon />}
                              pagination
                              paginationComponentOptions={paginationComponentOptions}
                              selectableRows
                              onSelectedRowsChange={handleChanges}
                              clearSelectedRows={toggledClearRows}
                              selectableRowDisabled={rowDisabledCriteria}
                              customStyles={customStyles}
                            />
                          </div>
                          <div className="clearfix" />
                        </div>
                      </div>
                    </div>
                  </div>

                )}

                {allocateBox && (
                  <div style={{ marginTop: "50px" }}>
                    <div classname="formbold-main-wrapper">
                      <div classname="formbold-form-wrapper">
                        <div className='trail'>
                          <div className='sub-trail'>
                            <SoftBox display="flex" alignItems="center">
                              <Switch checked={rememberMe} onChange={handleSetRememberMe} />
                              <SoftTypography
                                variant="button"
                                fontWeight="regular"
                                onClick={handleSetRememberMe}
                                sx={{ cursor: "pointer", userSelect: "none" }}
                              >
                                &nbsp;&nbsp;Assign directly using Retailer ID
                              </SoftTypography>
                            </SoftBox>

                            <SoftBox display="flex" alignItems="center" className="second-Button">
                              <Switch checked={rememberMe1} onChange={handleSetRememberMe1} />
                              <SoftTypography
                                variant="button"
                                fontWeight="regular"
                                onClick={handleSetRememberMe1}
                                sx={{ cursor: "pointer", userSelect: "none" }}
                              >
                                &nbsp;&nbsp;Search Store & Allocate Recharge Voucher
                              </SoftTypography>
                            </SoftBox>
                          </div>

                          {retailerBox && (
                            <SoftBox component="form" role="form" style={{ width: "20%" }} mx={"5%"}>
                              <SoftBox mb={2}>
                                <SoftBox>
                                  <SoftTypography component="label" variant="caption" fontWeight="bold" style={{ fontSize: "20px" }}>
                                    Enter Retailer ID <span class="astrix-color">*</span>
                                  </SoftTypography>
                                </SoftBox>
                                <SoftInput type="text" placeholder="Enter Retailer Id" name="retailer_code" value={showRetailerId} autoComplete="off" onChange={handlePidChange} />

                                {delearDetails && (
                                  <div className='details'>
                                    <h6 className='details-name'>Dealer Name:{name}</h6>
                                    <h6 className='details-company'>Company/Store Name:{company}</h6>
                                    <h6 className='details-address'>Dealer Address:{retailerAddress}</h6>
                                  </div>

                                )}

                              </SoftBox>
                              {button ? (
                                <SoftBox mt={2} mb={2} className="allocate" >
                                  <SoftButton variant="gradient" className="allocate-button" style={{ backgroundColor: "#C11D6C", color: "white" }} onClick={handleAllocate}>
                                    Allocate
                                  </SoftButton>
                                </SoftBox>
                              ) : (
                                <SoftBox mt={2} mb={2} style={{ paddingBottom: "60px" }}>
                                  <SoftButton variant="gradient" style={{ backgroundColor: "#C11D6C", color: "white" }} onClick={handleSubmit}>
                                    submit
                                  </SoftButton>
                                </SoftBox>
                              )}
                            </SoftBox>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        }
        <>
        </>
      </>
    </DashboardLayout>

  )
}
export default SearchAndAllocateReachargeVoucher